export default () => {
  document.querySelectorAll('[data-select2-static="true"]').forEach((select) => {
    $(select).select2({
      width: '100%',
      placeholder: gon.t.prompt,
    });
  });
};
